import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { BillingTemplateModalContent } from './modalContent/modalContent';
export const BillingTemplateModal = observer(_ref => {
  var _store$homeDashboardS;
  let isOpen = _ref.isOpen,
    handleClose = _ref.handleClose,
    propertyUtility = _ref.propertyUtility;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    variant: "large",
    title: t("add_new_property_flow.".concat(!!propertyUtility && propertyUtility.propertyUtilityId !== 'NEW_TEMPLATE' ? 'edit_billing_template' : 'add_billing_template')),
    subTitle: (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.buildingInformation) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.buildingAddress,
    trigger: null,
    isOpen: isOpen,
    handleClose: handleClose
  }, /*#__PURE__*/React.createElement(BillingTemplateModalContent, {
    propertyUtility: propertyUtility,
    handleClose: handleClose,
    isEditing: !!propertyUtility && propertyUtility.propertyUtilityId !== 'NEW_TEMPLATE'
  }));
});